export const validPasswordReg = /^((?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%?^&*])(?=.{10,}))/;
